import {CareServicesView} from '../../../../../../components/care-services/care-services-view';

export function ProfessionalsCareServicesProfessionalCaregiverScreen() {
  return <CareServicesView mode="seniors" />;
}
